class AcCards {
	constructor(container) {
		if (!container) {
			throw new Error('container e undefined.');
		}

		this.cards = container.querySelectorAll('.ac-card');
		if (this.cards.length === 0) {
			throw new Error('Nu am gasit clasa .ac-card in container.');
		}

		this.ratesSelectors = container.querySelectorAll('.rates-selector');
		if (this.ratesSelectors.length === 0) {
			throw new Error('ratesSelectors e gol.');
		}

		this.powerLevelSelector = container.querySelector('#cards-power-levels');
		if (!this.powerLevelSelector) {
			throw new Error('powerLevelSelector e undefined.');
		}

		this.cardContainers = container.querySelectorAll('.ac-cards');
		if (this.cardContainers.length === 0) {
			throw new Error('cardContainers e gol.');
		}

		this.form = {
			container: document.getElementById(container.dataset.formId),
			powerLevelSelector: document.getElementById(container.dataset.powerSelectorId || 'putere-aer-conditionat'),
			modelSelector: document.getElementById(container.dataset.modelSelectorId || 'aer-conditionat'),
		};

		this.selectedPower = this.powerLevelSelector.value;
		this.selectedModel = '';

		this.addListeners();
	}

	selectCard(card) {
		if (card.classList.contains('out-of-stock')) {
			return;
		}

		card.classList.add('selected');
		[...this.cards].filter((c) => c !== card).forEach((c) => c.classList.remove('selected'));
		this.selectedModel = card.dataset.name;
	}

	prepopulateForm() {
		if (this.form.powerLevelSelector && this.selectedPower) {
			this.form.powerLevelSelector.value = this.selectedPower;
			// Trigger change event ca sa se populeze/activeze selectul de model
			this.form.powerLevelSelector.dispatchEvent(new Event('change', { bubbles: true }));
		}

		if (this.form.modelSelector && this.selectedModel) {
			this.form.modelSelector.value = this.selectedModel;
		}
	}

	addListeners() {
		// Update carduri putere selectata
		this.powerLevelSelector.addEventListener('change', () => {
			this.selectedPower = this.powerLevelSelector.value;
			const cardsContainerToShow = document.getElementById(`ac-cards-${this.selectedPower}`);

			if (!cardsContainerToShow) {
				return;
			}

			cardsContainerToShow.hidden = false;
			[...this.cardContainers].filter((c) => c !== cardsContainerToShow).forEach((c) => (c.hidden = true));
		});

		// Handle card click
		for (let card of this.cards) {
			card.addEventListener('click', (e) => {
				if (e.target.closest('a, button, input, select, textarea')) {
					return;
				}
				this.selectCard(card);
				this.prepopulateForm();
			});
		}

		// Handle buton "Solicită o ofertă" click
		for (let card of this.cards) {
			const btn = card.querySelector('.scroll-to-form-btn');
			if (btn) {
				btn.addEventListener('click', (e) => {
					e.preventDefault();

					this.selectCard(card);
					this.prepopulateForm();

					// Scroll la formular
					if (this.form.container) {
						const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
						const offset = 32;

						if (viewportWidth < 993) {
							this.form.container.style.scrollMargin = `${offset}px`;
						} else {
							const header = document.getElementById('masthead');
							const headerHeight = (header && header.offsetHeight) || 0;
							this.form.container.style.scrollMargin = `${headerHeight + offset}px`;
						}

						this.form.container.scrollIntoView({
							behavior: 'smooth',
						});
					}
				});
			}
		}

		// Update preturi
		for (let selector of this.ratesSelectors) {
			selector.addEventListener('change', () => {
				const parentCard = selector.closest('.ac-card');
				const discount = parentCard?.querySelector('.discount-total');
				const monthlyRate = parentCard?.querySelector('.price');

				let priceData;
				try {
					priceData = JSON.parse(parentCard.dataset.prices)[selector.value];
				} catch (err) {
					console.warn('Nu am putut decodifica preturile.', err.message);
				}

				if (!monthlyRate || !priceData) {
					return;
				}

				discount && (discount.textContent = priceData.total_discount);
				monthlyRate.textContent = priceData.monthly_rate;
			});
		}
	}
}

function initCards() {
	new AcCards(document.getElementById('ac-cards'));
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCards);
} else {
	initCards();
}
